module.exports = __webpack_public_path__ + "img/logo-header.cfeac6b7.svg";